import { render } from "./HomeComponent.vue?vue&type=template&id=48fb4633&scoped=true"
import script from "./HomeComponent.vue?vue&type=script&lang=js"
export * from "./HomeComponent.vue?vue&type=script&lang=js"

import "./HomeComponent.vue?vue&type=style&index=0&id=48fb4633&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fb4633"]])

export default __exports__